import { API_TAGS } from "../../helpers/constants";
// Добавляем тег для панорамных изображений, если его нет
// Этот комментарий нужно будет удалить, если API_TAGS.PANORAMIC уже существует
import { convertBase64ToBlob } from "../../helpers/funcs";
import { IImg } from "../../types/Case";
import {
  IGetTRGSAnalysisTypesAllResponseProps,
  IGetTRGSMeasurementsAllRequestProps,
  IGetTRGSMeasurementsAllResponseProps,
  IGetTRGSPointsAIResponseProps,
  IGetTRGSPointsResponseProps,
  IPostCasesTRGSReportDataResponse,
  IPostCasesTRGSReportRequest,
  IPostUploadTRGImageRequestProps,
  IPutTRGSCalibrateRequestProps,
  ITRGMask,
  ITrgsPoint,
} from "../../types/TRG";
import { api } from "../api";

export const trgApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTRGSImage: builder.query<IImg, number | string>({
      query: (caseId) => ({ url: `cases/trgs/image/${caseId}` }),
      transformResponse: async (response: IImg): Promise<IImg> => {
        const splittedName = response.name.split(".");
        const blob = convertBase64ToBlob(
          `data:image/${splittedName[splittedName.length - 1]};base64,${
            response.image
          }`
        );
        const url = URL.createObjectURL(blob);
        return {
          ...response,
          image: url,
          size: blob.size,
        };
      },
      providesTags: () => [API_TAGS.TRG],
    }),
    // TRG изображения - создание
    postUploadTRGSImage: builder.mutation<
      unknown,
      { caseId: number | string } & IPostUploadTRGImageRequestProps
    >({
      query: ({ caseId, file }) => ({
        url: `cases/trgs/image/${caseId}`,
        method: "POST",
        body: file,
      }),
      extraOptions: {},
      invalidatesTags: [API_TAGS.TRG, API_TAGS.CASE],
    }),
    postUploadPhotosImage: builder.mutation<
      unknown,
      { caseId: number | string } & any
    >({
      query: ({ caseId, files }) => ({
        url: `cases/photo-protocol/create-batch?caseId=${caseId}`,
        method: "POST",
        body: files,
      }),
      extraOptions: {},
      invalidatesTags: [API_TAGS.TRG, API_TAGS.CASE],
    }),
    // Получение лицевых ориентиров с помощью ИИ
    getPhotoProtocolFaceLandmarksAI: builder.query<any, number | string>({
      query: (id) => ({ url: `cases/photo-protocol/${id}/face-landmarks/ai` }),
      providesTags: () => [API_TAGS.TRG],
    }),
    // TRG изображения - обновление
    postReUploadTRGSImage: builder.mutation<
      unknown,
      { caseId: number | string } & IPostUploadTRGImageRequestProps
    >({
      query: ({ caseId, file }) => ({
        url: `cases/trgs/image/${caseId}/reupload`,
        method: "POST",
        body: file,
      }),
      extraOptions: {},
      invalidatesTags: [API_TAGS.TRG, API_TAGS.CASE],
    }),
    putTRGSCalibrate: builder.mutation<
      unknown,
      { caseId: number | string } & IPutTRGSCalibrateRequestProps
    >({
      query: ({ caseId, ...credentials }) => ({
        url: `cases/trgs/calibrate/${caseId}`,
        method: "PUT",
        body: credentials,
      }),
      extraOptions: {},
      invalidatesTags: [API_TAGS.TRG, API_TAGS.CASE],
    }),
    // -------------------------------------------------------------------------------------------
    getCasesTRGSPointsAI: builder.query<
      IGetTRGSPointsAIResponseProps,
      number | string
    >({
      query: (caseId) => ({ url: `cases/trgs/points/ai/${caseId}` }),
      providesTags: () => [API_TAGS.TRG],
    }),
    getCasesTRGSPoints: builder.query<
      IGetTRGSPointsResponseProps,
      number | string
    >({
      query: (caseId) => ({ url: `cases/trgs/points/${caseId}` }),
      providesTags: () => [API_TAGS.TRG],
    }),
    getCasesTRGSDelineationAI: builder.query<ITRGMask, number | string>({
      query: (caseId) => ({ url: `cases/trgs/delineation/ai/${caseId}` }),
      transformResponse: async (response: ITRGMask): Promise<ITRGMask> => {
        // const splittedName = response.name.split(".");
        return {
          ...response,
          mask: `data:image;base64,${response.mask}`,
        };
      },
      providesTags: () => [API_TAGS.TRG],
    }),
    getCasesTRGSDelineation: builder.query<ITRGMask, number | string>({
      query: (caseId) => ({ url: `cases/trgs/delineation/${caseId}` }),
      transformResponse: async (response: ITRGMask): Promise<ITRGMask> => {
        // const splittedName = response.name.split(".");
        if (response.mask) {
          return {
            ...response,
            mask: `data:image;base64,${response.mask}`,
          };
        } else {
          return {
            ...response,
            mask: `data:image;base64,${response.image}`,
          };
        }
      },
      providesTags: () => [API_TAGS.TRG],
    }),
    // -------------------------------------------------------------------------------------------
    getTRGSPointsAll: builder.query<{ content: ITrgsPoint[] }, undefined>({
      query: () => ({ url: `/trgs/points/all` }),
      providesTags: () => [API_TAGS.TRG],
    }),
    getTRGSPoints: builder.query<ITrgsPoint, string | number>({
      query: (id) => ({ url: `/trgs/points/${id}` }),
      providesTags: () => [API_TAGS.TRG],
    }),
    getTRGSMeasurementsAll: builder.query<
      IGetTRGSMeasurementsAllResponseProps,
      IGetTRGSMeasurementsAllRequestProps
    >({
      query: (params) => ({
        url: `/trgs/measurements/all`,
        params: params,
      }),
      providesTags: () => [API_TAGS.TRG],
    }),
    getTRGSPointsImage: builder.query<IImg, string | number>({
      query: (id) => ({ url: `/trgs/points/image/${id}` }),
      providesTags: () => [API_TAGS.TRG],
      transformResponse: async (response: IImg): Promise<IImg> => {
        const splittedName = response.name.split(".");
        return {
          ...response,
          image: `data:image/${splittedName[splittedName.length - 1]};base64,${
            response.image
          }`,
        };
      },
    }),
    postCasesTRGSPoints: builder.mutation<
      unknown,
      { caseId: number | string; data: FormData }
    >({
      query: ({ caseId, data }) => ({
        url: `cases/trgs/points/${caseId}`,
        method: "POST",
        body: data,
      }),
      extraOptions: {},
      invalidatesTags: [API_TAGS.TRG, API_TAGS.CASE],
    }),
    postCasesPanoramic: builder.mutation<unknown, { caseId: number | string }>({
      query: ({ caseId }) => ({
        url: `cases/panoramic-image/${caseId}/image`,
        responseHandler: (response) => response.blob(),
      }),
      transformResponse: (response: Blob) => URL.createObjectURL(response),
      extraOptions: {},
      invalidatesTags: [API_TAGS.PANORAMIC],
    }),
    createPanoramicImage: builder.mutation<unknown, { formData: FormData }>({
      query: ({ formData }) => ({
        url: `cases/panoramic-image`,
        method: "POST",
        body: formData,
        responseHandler: (response) => response.blob(),
      }),
      transformResponse: (response: Blob) => URL.createObjectURL(response),
      extraOptions: {},
      invalidatesTags: [API_TAGS.PANORAMIC, API_TAGS.CASE],
    }),
    updatePanoramicImage: builder.mutation<
      unknown,
      { id: number | string; file: FormData }
    >({
      query: ({ id, file }) => ({
        url: `cases/panoramic-image/${id}`,
        method: "PUT",
        body: file,
        responseHandler: (response) => response.blob(),
      }),
      transformResponse: (response: Blob) => URL.createObjectURL(response),
      extraOptions: {},
      invalidatesTags: [API_TAGS.PANORAMIC, API_TAGS.CASE],
    }),
    deletePanoramicImage: builder.mutation<void, number | string>({
      query: (id) => ({
        url: `cases/panoramic-image/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [API_TAGS.PANORAMIC, API_TAGS.CASE],
    }),
    // Получение данных панорамного снимка (с комментарием)
    getPanoramicImageData: builder.query<
      { id: number; comment: string | null },
      number | string
    >({
      query: (id) => ({ url: `cases/photo-protocol/${id}` }),
      providesTags: () => [API_TAGS.PANORAMIC],
    }),
    // Обновление комментария панорамного снимка (использует тот же endpoint что и photo-protocol)
    updatePanoramicImageComment: builder.mutation<
      void,
      { id: number | string; comment: string }
    >({
      query: ({ id, comment }) => {
        const formData = new FormData();
        formData.append("comment", comment);
        return {
          url: `cases/photo-protocol/${id}`,
          method: "PUT",
          body: formData,
        };
      },
      invalidatesTags: [API_TAGS.PANORAMIC],
    }),
    postCasesTRGSOneClick: builder.mutation<
      unknown,
      { caseId: number | string }
    >({
      query: ({ caseId }) => ({
        url: `cases/trgs/one-click/${caseId}`,
        method: "POST",
      }),
      extraOptions: {},
      invalidatesTags: [],
    }),
    postCasesTRGSPointsNotReady: builder.mutation<
      unknown,
      { caseId: number | string; data: FormData }
    >({
      query: ({ caseId, data }) => ({
        url: `cases/trgs/points/${caseId}?ready=false`,
        method: "POST",
        body: data,
      }),
      extraOptions: {},
      invalidatesTags: [API_TAGS.TRG, API_TAGS.CASE],
    }),
    // postCasesPanoramic: builder.mutation<unknown, { caseId: number | string }>({
    //   query: ({ caseId }) => ({
    //     url: `cases/panoramic-image/${caseId}/image`,
    //     responseHandler: (response) => response.blob(),
    //   }),
    //   transformResponse: (response: Blob) => URL.createObjectURL(response),
    //   extraOptions: {},
    //   invalidatesTags: [],
    // }),
    getTRGSAnalysisTypes: builder.query({
      query: () => ({ url: `/trgs/analysis-types/all` }),
      providesTags: () => [API_TAGS.TRG],
      transformResponse: async (
        response: IGetTRGSAnalysisTypesAllResponseProps
      ): Promise<{ value: number; label: string }[]> => {
        return response.content.map(({ id, name }) => ({
          value: id,
          label: name,
        }));
      },
    }),
    postCasesTRGSReport: builder.mutation<
      IImg,
      { body: IPostCasesTRGSReportRequest; caseId: string }
    >({
      query: ({ caseId, body }) => ({
        url: `cases/trgs/report/${caseId}`,
        method: "POST",
        body,
      }),
      transformResponse: async (response: IImg): Promise<IImg> => {
        const blob = convertBase64ToBlob(
          `data:application/pdf;base64,${response.image}`
        );
        const url = URL.createObjectURL(blob);
        return {
          ...response,
          image: url,
        };
      },
      extraOptions: {},
      invalidatesTags: [],
    }),
    postCasesTRGSReportData: builder.mutation<
      IPostCasesTRGSReportDataResponse,
      { body: IPostCasesTRGSReportRequest; caseId: string }
    >({
      query: ({ caseId, body }) => ({
        url: `cases/trgs/report/data/${caseId}`,
        method: "POST",
        body,
      }),
      transformResponse: async (
        response: IPostCasesTRGSReportDataResponse
      ): Promise<IPostCasesTRGSReportDataResponse> => {
        const blob = convertBase64ToBlob(
          `data:application/image;base64,${response.image}`
        );
        const url = URL.createObjectURL(blob);
        const delineationBlob = convertBase64ToBlob(
          `data:application/image;base64,${response.image}`
        );
        const delineationUrl = URL.createObjectURL(delineationBlob);
        return {
          ...response,
          image: url,
          delineation: delineationUrl,
        };
      },
      extraOptions: {},
      invalidatesTags: [],
    }),
    // TRG изображения - удаление
    deleteTRGImage: builder.mutation<void, number | string>({
      query: (caseId) => ({
        url: `cases/trgs/image/${caseId}`,
        method: "DELETE",
      }),
      invalidatesTags: [API_TAGS.TRG, API_TAGS.CASE],
    }),
  }),
});

export const {
  // TRG изображения
  usePostUploadTRGSImageMutation,
  usePostReUploadTRGSImageMutation,
  useGetTRGSImageQuery,
  useDeleteTRGImageMutation,

  // Фото протокол
  usePostUploadPhotosImageMutation,
  useGetPhotoProtocolFaceLandmarksAIQuery,
  useLazyGetPhotoProtocolFaceLandmarksAIQuery,

  // Панорамные изображения
  usePostCasesPanoramicMutation,
  useCreatePanoramicImageMutation,
  useUpdatePanoramicImageMutation,
  useDeletePanoramicImageMutation,
  useGetPanoramicImageDataQuery,
  useUpdatePanoramicImageCommentMutation,

  // TRG точки и калибровка
  usePostCasesTRGSPointsMutation,
  usePostCasesTRGSPointsNotReadyMutation,
  usePutTRGSCalibrateMutation,
  useLazyGetCasesTRGSPointsAIQuery,
  useLazyGetCasesTRGSDelineationAIQuery,
  useGetCasesTRGSDelineationQuery,
  useLazyGetCasesTRGSDelineationQuery,
  useGetCasesTRGSPointsQuery,
  useLazyGetCasesTRGSPointsQuery,
  useGetTRGSPointsQuery,
  useGetTRGSPointsAllQuery,
  useGetTRGSPointsImageQuery,

  // TRG измерения и отчеты
  useLazyGetTRGSMeasurementsAllQuery,
  useGetTRGSAnalysisTypesQuery,
  useGetTRGSMeasurementsAllQuery,
  usePostCasesTRGSReportMutation,
  usePostCasesTRGSReportDataMutation,
  usePostCasesTRGSOneClickMutation,
} = trgApi;
